import React from 'react';
import { Icon } from 'components/common/icons/Icon';

const triggerIntercomMessage = () => {
    const message = 'Hi, I would like to learn more about SalesScreen!';
    if (typeof window !== 'undefined' && window.Intercom) {
        window.Intercom('showNewMessage', message);
    }
};

export const ContactOptionsInline = () => {
    return (
        <div className="tw-text-xs">
            <div className="tw-flex tw-gap-8 tw-items-center">
                <Icon icon="email" />
                <div className="tw-flex ">
                    <div>
                        If you have other questions feel free to send a mail to
                        <a className="tw-text-sm tw-ml-4 tw-underline" href="mailto:hi@salesscreen.com">
                            hi@salesscreen.com
                        </a>
                    </div>
                </div>
            </div>
            <div
                className="tw-flex tw-gap-8 tw-items-center tw-mt-12 hover:tw-cursor-pointer "
                onClick={triggerIntercomMessage}
            >
                <Icon icon="customer-care-filled" />
                <div className="hover:tw-underline">
                    Our support team is also available on chat if you have any product related
                    questions. Click here to open a new chat!
                </div>
            </div>
        </div>
    );
};
